var _line, _circle, _rect, _rect2, _rect3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _rect4, _rect5, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290 58",
    width: 290,
    height: 58,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 4,
    x2: 26,
    y2: 12,
    stroke: "#065183",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 3,
    r: 2.5,
    fill: "#0ea5e9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 19,
    width: 5,
    height: 12,
    rx: 2.5,
    ry: 2.5,
    fill: "#065183",
    opacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 19,
    width: 5,
    height: 12,
    rx: 2.5,
    ry: 2.5,
    fill: "#065183",
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 38,
    height: 34,
    rx: 7,
    ry: 7,
    fill: "#065183"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 25,
    r: 6,
    fill: "none",
    stroke: "rgba(255,255,255,0.2)",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 25,
    r: 6,
    fill: "none",
    stroke: "rgba(255,255,255,0.2)",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 25,
    r: 4.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 25,
    r: 4.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 23.5,
    r: 1.2,
    fill: "rgba(14,165,233,0.4)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 23.5,
    r: 1.2,
    fill: "rgba(14,165,233,0.4)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 25,
    r: 1.8,
    fill: "#065183"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 25,
    r: 1.8,
    fill: "#065183"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 37,
    width: 22,
    height: 5,
    rx: 2.5,
    ry: 2.5,
    fill: "rgba(255,255,255,0.6)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 38.5,
    width: 18,
    height: 2,
    rx: 1,
    fill: "rgba(255,255,255,0.35)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 30,
    fontFamily: "'Segoe UI', Arial, sans-serif",
    fontSize: 20,
    fontWeight: 800,
    fill: "#065183",
    letterSpacing: 0.5
  }, "Chatbot")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 48,
    fontFamily: "'Segoe UI', Arial, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#065183",
    opacity: 0.6,
    letterSpacing: 2
  }, "GoldTarget")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a2e34859b127370d9e0bca7c7066054.svg";
export { ForwardRef as ReactComponent };